<template>
  <!-- Site wrapper -->
  <div>
    <!-- Main content -->
    <section class="content">
      <!-- Default box -->
      <div class="row">
        <div class="col-md-12 grid-margin stretch-card">
          <form class="forms-sample">
            <div class="form-row">
              <div class="row col-md-12">
                <div class="form-group col-md-12 col-lg-12 col-xl-12">
                  <label for="email">E-mail</label>
                  <input
                    type="text"
                    v-model="formulario.contato.email"
                    :disabled="desabilitarCampos"
                    class="form-control"
                    id="email"
                  />
                  <div class="avisoDanger text-left mt-1">
                    {{ dadosRetorno.listaDeErros.email }}
                  </div>
                </div>
                <div class="form-group col-md-12 col-lg-12 col-xl-6">
                  <label for="celular">Celular</label>
                  <input
                    type="text"
                    v-mask="mascaraFone(formulario.contato.celular)"
                    v-model="formulario.contato.celular"
                    :disabled="desabilitarCampos"
                    class="form-control"
                    id="celular"
                  />
                  <div class="avisoDanger text-left mt-1">
                    {{ dadosRetorno.listaDeErros.celular }}
                  </div>
                </div>
                <div class="form-group col-md-12 col-lg-12 col-xl-6">
                  <label for="fone">Fone</label>
                  <input
                    type="text"
                    v-mask="mascaraFone(formulario.contato.fone)"
                    v-model="formulario.contato.fone"
                    :disabled="desabilitarCampos"
                    class="form-control"
                    id="fone"
                  />
                  <div class="avisoDanger text-left mt-1">
                    {{ dadosRetorno.listaDeErros.fone }}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <!-- card-body ends -->
      </div>
      <!-- card ends -->
    </section>
    <!-- /.content -->
  </div>
  <!-- ./wrapper -->
</template>

<script>
import Contato from './js/contato'
export default Contato
</script>
